const Host = require('./hosts')

const { stockDiagnosisHost, gmgQuoteHost, quotes, money, rankHost, circle, sms, user, rjhyNewsHost, activity} = Host(process.env.NODE_ENV);
const channel = 'channelH5'
// fdzqQuote

module.exports = {
  quote: {
    hotSerchAdd: `${gmgQuoteHost}/stock/hotSearch/add`,
    getLv2AdayInfo: ``, // A股主力资金今日jing
    getStockName: `${gmgQuoteHost}/getstockname`, // 获取个股名称
    getmainbusiness: `${gmgQuoteHost}/stock/quotes/getmainbusiness`, // 获取股票的主营业务
    queryStockSearch: `${gmgQuoteHost}/searchshszv1`, // 个股模糊搜索
    getAShareProfile: `${gmgQuoteHost}/stock/quotes/getAShareProfile`, // A股公司简况
    getDividendDistribution: `${gmgQuoteHost}/stock/quotes/getDividendDistribution`, // 分红配送
    hotSearchV2: `${gmgQuoteHost}/stock/hotSearchV2`, // 分红配送
    hotSearchV3: `${gmgQuoteHost}/stock/hotSearchV3`, // 分红配送
    getStockAlarm: `${gmgQuoteHost}/stock/alarm/getStockAlarm`, // 沪深A股个股异动
    getStockThemes: `${gmgQuoteHost}/stock/quotes/getStockThemes`, // 概念机会分析
    articles: `${gmgQuoteHost}/stock/articles`, // 查询资讯列表
    newsOne: `${gmgQuoteHost}/report/news/one`, // 研报列表
    ratingInfo: `${gmgQuoteHost}/report/rating/info`, // 研报评级统计
    profitInfo: `${gmgQuoteHost}/report/profit/info`, // 研报盈利评测
    newsDetail: `${gmgQuoteHost}/stock/newsDetail`, // 资讯详情
    detailByNewsId: `${gmgQuoteHost}/report/news/detailByNewsId`, // 研报详情
    announcementDetail: `${gmgQuoteHost}/stock/announcementDetail`, // 公告详情
    gene: `${gmgQuoteHost}/stock/quote/gene`, // 涨停基因
    stockDetail: `${gmgQuoteHost}/stock/detailv1`,
    getFdStockDetail: `${gmgQuoteHost}/stock/quotes/getFdStockDetail`,
    httpV30: `${quotes}/api/v30`, // test
    getBillList: `${money}/api/openapi.php/CN_Bill.GetBillList`, // 大单 ?num=100000&symbol=sz300344
    getKline: `${gmgQuoteHost}/stock/quote/v1/historyv1`,
    getIEKline: `${gmgQuoteHost}/stock/quote/v30v2`,
    getStatistics: `${gmgQuoteHost}/stock/quote/lastprice`,
    getsigntoken: `${gmgQuoteHost}/symbol/getsigntoken`, // 获取签名
    tradingdays: `${gmgQuoteHost}/stock/tradingdays`, // 最近交易日 ?market=sh&limit=3
    scrollbar: `${gmgQuoteHost}/stock/quote/scrollbar`, // 新闻速递滚动条
    hsFinance: `${gmgQuoteHost}/stock/quote/finance/report/detail`, // A股财务
    financeStockQuota: `${gmgQuoteHost}/stock/quotes/getStockQuota`, // 港美股财务
    financeStockFinance: `${gmgQuoteHost}/stock/quotes/getStockFinance`, // 港美股财务
    hkStockInfoList: `${gmgQuoteHost}/stock/quotes/getHKStockData` , // 港股简讯
    usStockInfoLists: `${gmgQuoteHost}/stock/quotes/getData`, //美股简讯
  },
  zbHttp: {
    'login': `/v30/login`, //  换取token
    'busi': `/v30/busi` // http 行情 v30
  },
  aiDiagnosis: {
    summary: `${stockDiagnosisHost}/jfztPc/BEEF00C14F8274BE5FACDDA11568F187/summary/stock/diagnosis`,
    coefficientChart: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/coefficientChart`,
    fundPerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/fundPerspective`,
    cashInflow: `${stockDiagnosisHost}/jfztPc/token/period/cash/inflow`,
    bigPerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/bigPerspective`,
    newsList: `${stockDiagnosisHost}/jfztPc/token/stock/news`,
    valuePerspective: `${stockDiagnosisHost}/jfztPc/stock/diagnosis/valuePerspective`,
  },
  rank: {
    summary: `${rankHost}/edu/stock/rank/summary`, //今日龙虎榜汇总
    list: `${rankHost}/edu/stock/rank/list`, //今日龙虎榜列表
    salesList: `${rankHost}/edu/department/rank/list`, //营业部列表
    stockDetail: `${rankHost}/edu/stock/rank/detail`, //营业部列表
    departmentDetail: `${rankHost}/edu/department/detail`, //营业部详情
    depOptionList: `${rankHost}/edu/department/opt/list`, //营业部操作记录
  },
  stockBar: {
    list: `${circle}/news/customer/stockbar/list/${channel}`, // 股吧列表
    publish: `${circle}/news/customer/publish/stockbar/unaudited/${channel}`,
    detail: `${circle}/news/customer/stockbar/detail/${channel}`,
    support: `${circle}/review/customer/support/news/${channel}`, // 点赞观点
    unSupport: `${circle}/review/customer/unSupport/news/${channel}`, // 取消点赞观点
    supportReview: `${circle}/review/customer/support/review/${channel}`, // 点赞评论
    unSupportReview: `${circle}/review/customer/unSupport/review/${channel}`, // 取消点赞评论
    publishDetail: `${circle}/review/customer/reviews/${channel}`,
    reviewList: `${circle}/news/customer/stockbar/review/list/${channel}`,
  },
  sms: {
    captcha: `${sms}/${channel}/captcha/sms/freesend`
  },
  user: {
    login: `${user}/user/${channel}/sms/login`
  },
  news: {
    getUkIndexNewsList: `${rjhyNewsHost}/1/ios/xl/stock/news/list`, // 港美指数资讯列表
    getUkIndexNewsDetail: `${rjhyNewsHost}/1/ios/xl/stock/news/detail` // 港美指数资讯详情
  },
  activity: {
    activity: `${activity}/activities/pages`
  }
}